import NotificationsPage from './notificationsPage.view';

export default NotificationsPage;
